import { createAction, props } from '@ngrx/store';
import { Category } from '@core/models';

export const CATEGORY_FIND = createAction('[Category] Find');
export const CATEGORY_FIND_SUCCESS = createAction('[Category] Find Success', props<{ categoryList: Category[] }>());
export const CATEGORY_FAILED = createAction('[Category] Failed', props<{ error: string }>());
export const CATEGORY_UPDATE_LOADING = createAction('[Category] Update Loading', props<{ loading: boolean }>());
export const CATEGORY_UPDATE_ID = createAction('[Category] Update Id Loading', props<{ categoryId: string }>());


